export const PATHS = {
  HOME: '/',
  APP_REDIRECT: '/app/*',
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  HOW_IT_WORKS: '/how-it-works',
  FOR_ORGANIZATIONS: '/for-organizations',
  PRICING: '/pricing',
  ABOUT: '/about',
  BLOG: '/blog',
  BLOGSBYID: '/blog/:id',
  CONTACT: '/contact',
  JOIN_BETA: '/download-otanu',
  FAQ: '/faq',
  TERMS_OF_SERVICE: '/terms-of-service',
  PRIVACY_POLICY: '/privacy-policy',
  CODE_OF_CONDUCT: '/code-of-conduct',
  COOKIE_POLICY: '/cookie-policy',
  REQUEST_DEMO: '/request-demo',
  DELETE_ACCOUNT: '/delete-account',
  CHILD_SAFETY_STANDARDS: '/child-safety-standards',
  NOT_FOUND: '*',
} as const;
